import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, MessageCircleQuestion, AlertCircle } from "lucide-react";
import { API } from "@/lib/api";
import { errMsg } from "./SocialPilotPanel";

const Kpi = ({ label, value, testid, warn }) => (
  <div className="border border-[#d5dbde] bg-white p-4">
    <div className="text-[10px] uppercase font-mono text-[#6b7280]">{label}</div>
    <div data-testid={testid} className={`font-display text-3xl ${warn ? "text-[#E0262C]" : ""}`}>{value ?? "—"}</div>
  </div>
);

const List = ({ title, icon: Icon, rows, testid, empty }) => (
  <section data-testid={testid} className="border border-[#d5dbde] bg-white">
    <h3 className="px-4 py-3 border-b border-[#e4e7e9] font-display text-base flex items-center gap-2"><Icon className="w-4 h-4 text-[#E0262C]" />{title}</h3>
    <ol className="divide-y divide-[#e4e7e9]">
      {rows.map((r, i) => (
        <li key={r.question + i} data-testid={`${testid}-row-${i}`} className="px-4 py-2.5 flex items-start gap-3 text-sm">
          <span className="font-mono text-[10px] text-[#9ca3af] w-5 pt-0.5">{i + 1}</span>
          <span className="flex-1">{r.question}</span>
          <span className="font-mono text-xs bg-[#f4f6f7] px-2 py-0.5">{r.count}×</span>
          <span className="font-mono text-[10px] text-[#9ca3af] whitespace-nowrap pt-0.5">{new Date(r.last).toLocaleDateString("it-CH")}</span>
        </li>
      ))}
      {!rows.length && <li className="px-4 py-4 text-xs text-[#6b7280]">{empty}</li>}
    </ol>
  </section>
);

export const ChatbotStatsPanel = () => {
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); axios.get(`${API}/admin/chatbot/stats`, { params: { days } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, [days]);
  return (
    <div data-testid="chatbot-stats" className="space-y-4">
      <div>
        <h2 className="font-display text-2xl">Statistiche chatbot</h2>
        <p className="text-sm text-[#6b7280]">Le domande più frequenti dei visitatori e quelle a cui il chatbot non ha saputo rispondere: usale per aggiornare listino, FAQ e card dei pacchetti.</p>
      </div>
      <div className="flex gap-2">{[7, 30, 90, 365].map((n) => (
        <button key={n} type="button" data-testid={`chatbot-stats-days-${n}`} onClick={() => setDays(n)} className={`h-9 px-3 text-xs border ${days === n ? "bg-[#2B3036] text-white border-[#2B3036]" : "border-[#d5dbde] bg-white"}`}>{n === 365 ? "1 anno" : `${n} giorni`}</button>
      ))}</div>
      {!d ? <Loader2 className="w-5 h-5 animate-spin" /> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <Kpi label="Conversazioni" value={d.sessions} testid="chatbot-stats-sessions" />
            <Kpi label="Domande" value={d.questions} testid="chatbot-stats-questions" />
            <Kpi label="Senza risposta" value={d.unanswered} testid="chatbot-stats-unanswered" warn={d.unanswered > 0} />
            <Kpi label="Tasso di risposta" value={d.answer_rate != null ? `${d.answer_rate}%` : null} testid="chatbot-stats-rate" />
          </div>
          <div className="grid lg:grid-cols-2 gap-4 items-start">
            <List title="Domande più frequenti" icon={MessageCircleQuestion} rows={d.top} testid="chatbot-stats-top" empty="Nessuna domanda nel periodo." />
            <List title="Domande senza risposta" icon={AlertCircle} rows={d.unanswered_list} testid="chatbot-stats-unknown" empty="Il chatbot ha risposto a tutte le domande." />
          </div>
        </>
      )}
    </div>
  );
};
